export default __webpack_public_path__ + "static/media/CVS_Logo.7c6450e6.svg";